import(/* webpackMode: "eager" */ "/vercel/path0/app/globals.css");
;
import(/* webpackMode: "eager", webpackExports: ["BounceTracker"] */ "/vercel/path0/components/bounce-tracker.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["GoogleAnalytics"] */ "/vercel/path0/components/google-analytics.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["GoogleCallTracking"] */ "/vercel/path0/components/google-call-tracking.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["SectionTracking"] */ "/vercel/path0/components/section-tracking.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["TrackingProvider"] */ "/vercel/path0/components/tracking-provider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Analytics"] */ "/vercel/path0/node_modules/@vercel/analytics/dist/react/index.mjs");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/font/google/target.css?{\"path\":\"app/layout.tsx\",\"import\":\"Inter\",\"arguments\":[{\"subsets\":[\"latin\"],\"display\":\"swap\",\"preload\":true,\"variable\":\"--font-inter\",\"fallback\":[\"system-ui\",\"-apple-system\",\"BlinkMacSystemFont\",\"Segoe UI\",\"Roboto\",\"sans-serif\"],\"weight\":[\"400\",\"500\",\"600\",\"700\"],\"adjustFontFallback\":true}],\"variableName\":\"inter\"}");
